// Mirrors AddressValidationSummary::NO_MATCH_SUMMARIES on the Ruby side: both
// summaries mean Smarty could not confirm a mailable address, so the admin
// treats them the same (review instead of accept).
export const NO_MATCH_SUMMARIES = ['No Match', 'No Match - PO Box Only'];

export const VALIDATED_BY_FINTRX = 'Validated By FINTRX';

export const isNoMatchSummary = (summary) => NO_MATCH_SUMMARIES.includes(summary);

export const noMatchSummaryOptions = () => NO_MATCH_SUMMARIES.map((summary) => ({id: summary, name: summary}));
